import values from 'lodash-es/values'
import flatten from 'lodash-es/flatten'

const stateGroups = {
  active: ['active', 'assigned'],
  draft: ['draft'],
  paused: ['paused', 'declined', 'auto_declined'],
  deleted: ['deleted'],
  fulfilled: ['fulfilled']
}

interface HasState {
  state: string;
}

const keywordStateGroups = Object.keys(stateGroups)
const keywordStates = flatten(values(stateGroups))

function stateGroupForKeyword<T extends HasState>(keyword: T): string {
  return Object.keys(stateGroups).find(group => stateGroups[group].includes(keyword.state))
}

function keywordStatesByGroup(group: string): string[] {
  return stateGroups[group]
}

export { stateGroups, keywordStates, keywordStateGroups, stateGroupForKeyword, keywordStatesByGroup }
